
<div class="breadcrumbs">
  <ul class="breadcrumbs__list">
    <li><a href="javascript:;" >General</a></li>
    <li><a href="javascript:;" [routerLink]="['/' + RouterLinks.Documents]" >Documents</a></li>
    <li>General documents</li>
  </ul>
</div>
<main class="page-main">
  <div class="layout layout--central">
    <div class="layout__row">
      <app-landing-left-sidebar></app-landing-left-sidebar>
      <div class="layout__bodycol">
        <header class="central-header d-none d-lg-flex">
          <div class="central-header__title">
            <h3>General documents</h3>
          </div>

        </header>
        <div class="row row--sm row--gap row--mh">
          @for (doc of documents; track doc) {
            <div class="col-12 col-md-6">
              <a href="javascript:;" (click)="openDocument(doc)" class="card card--document">
                <div class="card-body">
                  <div class="card__content">
                    <h5 class="font-16">{{doc?.document_name}}</h5>
                    <p><small></small></p>
                  </div>
                  <div class="card__caret">
                    <svg class="icon">
                      <use xlink:href="#chevron-right"></use>
                    </svg>
                  </div>
                </div>
              </a>
            </div>
          }

        </div>





      </div>
    </div>
  </div>
</main>
<app-disclaimer></app-disclaimer>



